import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { View, ScrollView, StyleSheet } from 'react-native'
import { createContainer } from '@dbk-legacy/muster/react'
import { Tabs, Tab } from '@dbk/ui-tabs';
import 'moment/min/locales';
import Text, { Large } from '@dbk/ui-text';
import { PAGE, CUSTOM_REPORT_SELECTED_RANGE, ReportTypes} from '../../../@extension/CH/src/screens/reports/constants';
import CalendarModal from '../../components/common/calendar-modal';
import { ChangeIndicatedCurrency } from '../../components/common/number';
import { CorrectPagination as Pagination } from '../../components/common/pagination';
import getPaginatedItems from '../../utils/get-paginated-items';
import additionalStyles from './custom-transactions.styles';
import { DatePicker, Utils } from '@dbk/ui-datepicker';
import moment from 'moment';
import { BasicNumber } from '@dbk/ui-numbers';
import Button from '@dbk/ui-buttons';
import { LoadingCircle } from '../../components/common/loading';
import SortingHeader from '../../components/common/sorting-header';
import InverseProvider from '@dbk/ui-inverse';
import { formatDate } from '../../../@extension/CH/src/screens/reports/report-utils';
import DismissableBar from '../payments/payment-error/dismissable-bar';
import { PALETTE, ASSET_TRADE_TYPE } from '../../constants';
import GenericDateSelectionBar from '../../components/common/date-selection-bar';
import { currentDateText } from '../../utils/date';

class TransactionHistory extends PureComponent {

  constructor(props) {
    super(props);
    const languageCode = this.props.auth.langCode;
    Utils.configLocale(languageCode, {
      week: {
        dow: 1, // Monday is the first day of the week.
        // dow: 0, // Sunday is the first day of the week.
      },
    });

    const asOfDate = moment(this.props.portfolio.overallMarketValue.asOfDate, 'YYYY-MM-DD').format('DD-MM-YYYY');
    const portfolioTransStartDate = moment(this.props.portfolio.overallMarketValue.portfolioTransStartDate, 'YYYY-MM-DD').format('DD-MM-YYYY');
    const portfolioTransEndDate = moment(this.props.portfolio.overallMarketValue.portfolioTransEndDate, 'YYYY-MM-DD').format('DD-MM-YYYY');

    // var asOfDate = moment("2020-01-06", 'YYYY-MM-DD').format('DD-MM-YYYY'); // WMCE-5065 for testing use latest As of Date(or T-1 date)

    this.state = {
      weekAgo: moment(portfolioTransEndDate, "DD-MM-YYYY").subtract(6, 'd').format('YYYY-MM-DD'),
      monthAgo: moment(portfolioTransEndDate, "DD-MM-YYYY").subtract(30, 'd').format('YYYY-MM-DD'),
      trimonthAgo: moment(portfolioTransEndDate, "DD-MM-YYYY").subtract(3, 'months').format('YYYY-MM-DD'),
      portfolioTransEndDate: moment(portfolioTransEndDate, 'DD-MM-YYYY').format('YYYY-MM-DD'),
      timeline: 0,
      // currentYear: new Date().getFullYear(),
      // lastYear: new Date().getFullYear() - 1,
      fromDate: 'date',
      toDate: 'date',
      selectedTab: 0,
      pageOffset: 0,
      currentTab: 0,
      downloadType: '',
      dateApplied: false,
      value: {
        from: moment().startOf('year'),
        to: moment(portfolioTransEndDate, "DD-MM-YYYY")
      },
      transactionDetails: []
    };

    this.props.setStartDate(moment(portfolioTransEndDate, "DD-MM-YYYY").subtract(6, 'd').format('YYYY-MM-DD'));
    this.props.setEndDate(moment(portfolioTransEndDate, 'DD-MM-YYYY').format('YYYY-MM-DD'));
   // const { hideDWOPortfolioSelector } = this.props;
    // hideDWOPortfolioSelector(true); No need to hide selector WMCE-4443

    // Utils.configLocale(languageCode, {
    //   week: {
    //     dow: 1, // Monday is the first day of the week.
    //     // dow: 0, // Sunday is the first day of the week.
    //   },
    // });
  }

  componentDidMount() {
    this.props.getTransactionDetails();
    this.props.setIsTransactionSelected(true);
    if(document.querySelector('.logo-web')){
      document.querySelector('.logo-web').focus();
    }
  }

  componentWillReceiveProps(nextProps) {

  //   const {
  //     app: {user: {selectedPortfolioData}},
  //     reports: {startDate, endDate ,custom}
  // } = this.props;
   /*  WMCE-6458 common selection widget */
  if(this.props.selectedPortfolioData && this.props.selectedPortfolioData.id !== nextProps.selectedPortfolioData.id 
      ){
          this.props.getTransactionDetails();
  }
  
    if (this.props.reports.custom.downloads.result !== nextProps.reports.custom.downloads.result) {
      const result = nextProps.reports.custom.downloads.result;
      this.excelDownload(
        this.jsonToXml(result),
        result.sheetname ? result.sheetname : this.state.downloadType + '.xls',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      );
      this.setState({ isLoading: false });
    }
  }

  componentWillUnmount() {
    this.props.setTransactionHistoryList([]);
    //const { hideDWOPortfolioSelector } = this.props;  Not required WMCE -4443
    // hideDWOPortfolioSelector(false);
    this.props.setIsTransactionSelected(false); 
  }

  componentDidUpdate(prevProps) {
    const {
      reports: { trans: { transactionHistoryList } } } = this.props;
    if (this.props.reports.closeDatePicker === true && this.datepickerRef && this.datepickerRef.datepicker && this.datepickerRef.datepicker.state && this.datepickerRef.datepicker.state.isOpen) {
      this.onCancel();
    }
    if( transactionHistoryList && this.state.transactionDetails.length !== transactionHistoryList.length ){
      this.setState({transactionDetails:transactionHistoryList});
      this.setPageOffset(0);
    }
  }

  excelDownload(content, filename, contentType) {
    if (!contentType) contentType = 'application/octet-stream';
    const anchor = document.createElement('a');
    const blob = new Blob([content], {
      type: contentType,
    });
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blob, filename);
    } else {
      anchor.href = (window.URL || window.webkitURL).createObjectURL(blob);
      anchor.download = filename;
    }
    anchor.style.display = 'none';
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  }

  jsonToXml(jsonObject) {
    let row;
    var col;
    let xml;
    const arrData =
      typeof jsonObject !== 'object' ? JSON.parse(jsonObject) : jsonObject;

    xml = this.createXmlHeader(arrData);

    for (const rowData in arrData.sections) {
      for (
        let resultsLength = 0;
        resultsLength < arrData.sections[rowData].results.length;
        resultsLength++
      ) {
        xml += '<ss:Row>\n';
        for (var col in arrData.sections[rowData].results[resultsLength]) {
          xml += '  <ss:Cell>\n';
          xml += '    <ss:Data ss:Type="String">';
          xml +=
            arrData.sections[rowData].results[resultsLength][col] +
            '</ss:Data>\n';
          xml += '  </ss:Cell>\n';
        }
        xml += '</ss:Row>\n';
      }
    }
    xml += this.createXmlFooter();
    return xml;
  }

  createXmlHeader(arrData) {
    let headerRow = '<ss:Row>\n';
    let dataRow = '';

    for (const preRow in arrData.sections) {
      dataRow +=
        '<ss:Row>' +
        '<ss:Cell ss:StyleID="xls-style-1"><ss:Data ss:Type="String">' +
        arrData.sections[preRow].name +
        '</ss:Data>' +
        '</ss:Cell>' +
        '</ss:Row>\n' +
        '<ss:Row>' +
        '<ss:Cell ss:StyleID="xls-style-1"><ss:Data ss:Type="String">' +
        arrData.sections[preRow].description +
        '</ss:Data>' +
        '</ss:Cell>' +
        '</ss:Row>\n';
      for (const index in arrData.sections[preRow].headers) {
        headerRow += '  <ss:Cell ss:StyleID="xls-style-1">\n';
        headerRow += '    <ss:Data ss:Type="String">';
        headerRow += arrData.sections[preRow].headers[index] + '</ss:Data>\n';
        headerRow += '  </ss:Cell >\n';
      }
    }

    headerRow += '</ss:Row>\n';
    return (
      '<?xml version="1.0"?>\n' +
      '<ss:Workbook xmlns:ss="urn:schemas-microsoft-com:office:spreadsheet">\n' +
      '<ss:Styles>\n' +
      '<ss:Style ss:ID="xls-style-1" ss:Name="xls-style-1">\n' +
      '<ss:Alignment ss:Vertical="Bottom" ss:Horizontal="Left"/>\n' +
      '<ss:Borders>\n' +
      '<ss:Border ss:Position="Bottom" ss:LineStyle="Continuous" ss:Weight="1" ss:Color="#DDDDDD"/>\n' +
      '<ss:Border ss:Position="Left" ss:LineStyle="Continuous" ss:Weight="1" ss:Color="#DDDDDD"/>\n' +
      '<ss:Border ss:Position="Right" ss:LineStyle="Continuous" ss:Weight="1" ss:Color="#DDDDDD"/>\n' +
      '<ss:Border ss:Position="Top" ss:LineStyle="Continuous" ss:Weight="1" ss:Color="#DDDDDD"/>\n' +
      '</ss:Borders>\n' +
      '<ss:Font ss:Color="#545454" ss:Bold="1" />\n' +
      '<ss:Interior ss:Color="#FFFFFF" ss:Pattern="Solid"/>\n' +
      '</ss:Style>\n' +
      '</ss:Styles>\n' +
      '<ss:Worksheet ss:Name="Sheet1">\n' +
      '<ss:Table>\n' +
      dataRow +
      '<ss:Row/>\n' +
      headerRow
    );
  }

  createXmlFooter() {
    return '</ss:Table>\n' + '</ss:Worksheet>\n' + '</ss:Workbook>\n';
  }

  setPageOffset = newOffset => {
    this.setState({ pageOffset: newOffset });
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }

  onSelectTime(selectedTab) {
    const { setStartDate, setEndDate, getTransactionDetails, setTransactionHistoryList, setTransSelectedTab } = this.props;
    const { weekAgo, monthAgo, trimonthAgo, portfolioTransEndDate} = this.state;
    this.setState({
      selectedTab,
      pageOffset: 0,
    });
    setTransSelectedTab(selectedTab);
    setTransactionHistoryList(undefined);
    if (selectedTab === CUSTOM_REPORT_SELECTED_RANGE.CUSTOM) {
      setStartDate(trimonthAgo);
      setEndDate(portfolioTransEndDate);
      this.handlePaginationChange();
      return;
    }

    switch (selectedTab) {
      case CUSTOM_REPORT_SELECTED_RANGE.LAST_WEEK:
        setStartDate(weekAgo); 
        break;
      case CUSTOM_REPORT_SELECTED_RANGE.LAST_MONTH:
        setStartDate(monthAgo);
        break;
      case CUSTOM_REPORT_SELECTED_RANGE.PAST_THREE_MONTHS:
        setStartDate(trimonthAgo);
        break;
      default:
        break;
    }
    setEndDate(portfolioTransEndDate);
    getTransactionDetails();
    this.handlePaginationChange();
  }

  addSign = num => num > 0 ? '+' + num : num;
  num2text = (num, addSign = false, digit = 2) => (
    <BasicNumber
      value={num}
      notANumberComponent={<Text secondary>-</Text>}
      addPlusSign={addSign}
    >
      {
        (text) => (<Text style={{ color: 'white' }}>{text.formattedValue}</Text>)
      }
    </BasicNumber >
  )

  renderRows(rows) {
    const {
      i18n: { messages },
      auth: { langCode }
    } = this.props
    return rows.map((row, index) => (

        <View style={StyleSheet.flatten(additionalStyles.root)}>
          <View style={StyleSheet.flatten(additionalStyles.container)}>
            <View style={StyleSheet.flatten(additionalStyles.listItemTransStart)}>
              <Text>{row.portfolioId} {row.pfCurr} </Text>
            </View>
            <View style={additionalStyles.listItemTransStart}>
              <Text>{row.tranTypeDesc}</Text>
            {/* <Text style={StyleSheet.flatten(additionalStyles.currencyStyle)} primary>{row.securityLongName}</Text> */}
            </View>
            <View style={additionalStyles.listItemTransStart}>
              <Text testID="text_date_customTransactionHistory_test" value={row.tradeDate}>
                {formatDate(row.tradeDate, langCode)}
              </Text>
            </View>
            <View style={additionalStyles.listItemFirst}>
              <Text  primary>{row.tradeType === ASSET_TRADE_TYPE.trade_type ? row.posDesc : row.securityLongName }</Text>
            </View>
            <View style={additionalStyles.listItemReference}>
              <Text secondary>{row.transactionNo} </Text>
            </View>
            <View style={additionalStyles.listItem}>
              {(row.qty === null || row.qty === undefined) ?
                <Text secondary>-</Text> : this.num2text(row.qty, true)}
            </View>
            <View style={additionalStyles.listItem}>
              {(row.price === null || row.price === undefined) ?
                <Text secondary>-</Text> : <div><Text>{row.ccyTrade}{" "}</Text>{this.num2text(row.price)}</div>}
            </View>
            <View style={additionalStyles.listItem}>
              {row.netAmtTradeCcy === null ? (
                '-'
              ) : (
                <div>
                  <ChangeIndicatedCurrency
                    value={parseFloat(row.netAmtTradeCcy)}
                    renderProps={{ size: 'small', style: additionalStyles.date, color: PALETTE.secondaryActive }}
                    onlyNegativeStyling
                    currency={row.ccyTrade}
                  />
                </div>
              )}
            </View>
          </View>
        </View>
    ));
  }


  callDirectExcelService(trxType) {
    this.setState({ isLoading: true });
    const {
      reports: { trans: { startDate, endDate } },
    } = this.props;
    this.setState({ downloadType: trxType });
    this.props
      .downLoadReport({
        reportname: trxType,
        fromDate: startDate,
        toDate: endDate
      })
      .then((success) => {
        this.setState({ isLoading: false });
      }).catch((error) => {
        this.setState({ isLoading: false });
      });
  }

  handlePaginationChange = () => {
    this.rootView.scrollTo({ y: 0 });
  }

  onDayClick = (selectionStart) => {
    const value = Utils.addDayToRange(
      selectionStart,
      this.state.value
    );
    this.setState({
      value,
    });
  };

  onChangeRange = (range) => {
    this.setState({
      value: {
        ...Utils.updateRangeWithReset(this.state.value, range)
      }
    });
  }

  onApplyDateChange = () => {
    // this.setState({dateApplied: true});
    this.props.getCustomDateRangeData(this.state.value.from, this.state.value.to);
    this.props.setCustomStartDate(this.state.value.from.format('YYYY-MM-DD'));
    this.props.setCustomEndDate(this.state.value.to.format('YYYY-MM-DD'));
    this.onCancel();
    // this.setState({dateApplied: false});
  }


  onCancel = () => {
    this.datepickerRef.datepicker.closeCalendar();
    this.props.setDatePickerClose(false);
  }

  customFooter = () => {
    const { i18n: { messages } } = this.props;
    return <InverseProvider inverse style={{ borderBottom: "1px solid #535b61", width: "100%", height: "60px", backgroundColor: '#12213c', paddingTop: "15px" }} >
      <div className='datepicker-footer-txt'>
        <Text style={{ padding: "5px" }}>{messages['app.chedelivery.reports.customReports.today']}{moment().format('DD-MMM-YYYY')}</Text>
      </div>
      <div className='datepicker-footer-btn'>
        <Button tertiary
          onClick={() => this.onCancel()}
        >{messages['app.chedelivery.reports.customReports.cancelButton']}</Button>

        <Button
          disabled={!(this.state.value.from && this.state.value.to)}
          onClick={() => this.onApplyDateChange()}
        >{messages['app.chedelivery.reports.apply']}</Button>
      </div>
    </InverseProvider>
  }

 

  render() {
    const {
      i18n: { messages },
      reports: { transactions: { showSpinner },
        trans: { transactionHistoryList, isLoading} },
      auth: { documentDownloadDisabled }
    } = this.props;
    let transactions = [];
    const { selectedTab, pageOffset } = this.state;
    const pageSize = PAGE.pageSize;
    let paginatedTransactions = [];

    if (transactionHistoryList && transactionHistoryList.length > 0) {
      transactions = transactionHistoryList;
      paginatedTransactions = getPaginatedItems(transactions, pageOffset, pageSize);
    }
    const asOfDate = moment(this.props.portfolio.overallMarketValue.asOfDate, 'YYYY-MM-DD').format('DD-MM-YYYY');
    //  var asOfDate = moment("2021-01-07", 'YYYY-MM-DD').format('DD-MM-YYYY'); // WMCE-5065 for testing use latest As of Date(or T-1 date)

    const startDate = moment(this.props.portfolio.overallMarketValue.portfolioTransStartDate, 'YYYY-MM-DD');
    const endDate = moment(this.props.portfolio.overallMarketValue.portfolioTransEndDate, 'YYYY-MM-DD');

    return (
      <div >
        <div>
          {/* <div>
            <ReportPortfolioSelector />  // WMCE- 4443, Using common app-header widget
          </div> */}
          <div className="row large-collapse">
            <div className="profile-container">
              <div id="title_report_transactions_test" className="profile-container__title" style={{ paddingLeft: 30 }}>
                <h2 tabIndex={0}>{messages['app.common.pageTitle.transactions']}</h2>
              </div>
              <View style={{ marginLeft: 20, marginRight: 20 }}>
                <Tabs
                  secondary
                  stretch
                  handleSelectedIndex={index => this.onSelectTime(index)}
                  selectedIndex={selectedTab}
                >
                  <Tab testID="tab_report_7days_reportCustomTransactionHistory_test" style={{ fontSize: 16, paddingHorizontal: 0 }} renderLabel={() => messages['app.incomehistory.7days']}  />
                  <Tab testID="tab_report_30days_reportCustomTransactionHistory_test" style={{ fontSize: 16, paddingHorizontal: 0 }} renderLabel={() => messages['app.report.transactionHistory.30days']}  />
                  <Tab testID="tab_report_3months_reportCustomTransactionHistory_test" style={{ fontSize: 16, paddingHorizontal: 0 }} renderLabel={() => messages['app.report.transactionHistory.90days']}  />
                  <Tab testID="tab_report_date_reportCustomTransactionHistory_test" style={{ fontSize: 16, paddingHorizontal: 0 }} renderLabel={() => messages['app.maturities.overview.tabs.labels.custom']}  />
                </Tabs>
              </View>
              <SortingHeader
                enabled={false}
                showBorder={false}
                messages={messages}
              />
              <div className="row">
                <div id="text_maturities_header_test" className="columns small-6 medium-7 large-9 padding-bottom-10">
                  {paginatedTransactions.length > 0 ?
                    <GenericDateSelectionBar
                        text={currentDateText((this.props.reports.trans.startDate).toString(), (this.props.reports.trans.endDate).toString(), messages)}
                      />
                    : ''}
                </div> 
                <span className="columns small-6 medium-5 large-3 ">
                  {selectedTab === CUSTOM_REPORT_SELECTED_RANGE.CUSTOM &&
                    <div className="customReportCalendar margin-10">
                      <View id="datepicker_reports_reportCustomTransactionHistory_test" style={additionalStyles.calendarContainer}>
                      { !this.props.logoutPopup.isVisible &&   <DatePicker
                          ref={(ref) => this.datepickerRef = ref}
                          showOutsideMonthDays={false}
                          canChangeMonth
                          enableYearNavigation
                          enableRangeSelection
                          onChange={this.onChangeRange}
                          value={this.state.value}
                          startDate={startDate}
                          endDate={endDate}
                          inputDateFormat={'DD MMM YYYY'}
                          selectionStart={this.state.value.from}
                          selectionEnd={this.state.value.to}
                          renderFooter={() => this.customFooter()}
                        />}
                      </View>
                    </div>
                  }  </span>
              </div>
            </div>
          </div>
        </div>

        <View style={{ clear: 'both', marginLeft: 7, marginRight: 17 }}>
          {
            <View>
              {isLoading || showSpinner === true ?
                <View style={StyleSheet.flatten(additionalStyles.loadingData)}><LoadingCircle /></View>
                :

                <div id="container_reports_reportCustomTransactionHistory_test" className="scrollBarHover" style={{ width: '100%' }}>
                  <ScrollView
                    className="scrollBarHide" id="scrollBarHide"
                    ref={r => this.rootView = r}
                    style={{ overflowY: "auto", overflowX: "hidden", maxHeight: "500px", minHeight:"410px" }}
                  >{paginatedTransactions.length > 0 ?
                      <div><View style={StyleSheet.flatten(additionalStyles.headerRoot)}>
                      <View style={StyleSheet.flatten(additionalStyles.container)}>
                        <View style={StyleSheet.flatten(additionalStyles.listItemTransStart)}>
                          <Text secondary>{messages['app.chedelivery.reports.customReports.txn.portfolio']}</Text>
                        </View>
                        <View style={additionalStyles.listItemTransStart}>
                          <Text secondary>{messages['app.report.transactionHistory.type']}</Text>
                        </View>
                        <View style={additionalStyles.listItemTransStart}>
                          <Text secondary>{messages['app.report.transactionHistory.tradeDate']}</Text>
                        </View>
                        <View style={additionalStyles.listItemFirst}>
                          <Text secondary>{messages['app.report.transactionHistory.desc']}</Text>
                        </View>
                        <View style={additionalStyles.listItemReference}>
                          <Text secondary>{messages['app.chedelivery.reports.customReports.txn.reference']}</Text>
                        </View>
                        <View style={additionalStyles.listItem}>
                          <Text secondary>{messages['app.report.transactionHistory.quantity']}</Text>
                        </View>
                        <View style={additionalStyles.listItem}>
                          <Text secondary>{messages['app.report.transactionHistory.price']}</Text>
                        </View>
                        <View style={additionalStyles.listItem}>
                          <Text secondary>{messages['app.report.transactionHistory.amount']}</Text>
                        </View>
                      </View>
                    </View>{this.renderRows(paginatedTransactions)}</div>
                    :
                    (transactionHistoryList !== undefined) ?
                      <div className="text-center margin-top-20">
                        <Large secondary> {messages['app.reports.noRecords']}</Large>
                      </div>
                      :
                      (transactionHistoryList !== undefined) ?
                        <div className="text-center margin-top-20">
                          <Large secondary> {messages['app.reports.noRecords']}</Large>
                        </div>
                        :
                        <div style={{ minHeight: '470px', position: "relative" }} />
                    }
                  </ScrollView>
                </div>
              }
            </View>
          }
          {(!isLoading || !showSpinner) && <Pagination
            pageOffset={pageOffset}
            pageSize={pageSize}
            totalRecords={transactions.length}
            setPageOffset={this.setPageOffset}
            onPageChange={this.handlePaginationChange}
            style={{ marginVertical: 20 }} />}
        </View>
      </div>
    );
  }
}

TransactionHistory.propTypes = {
  i18n: PropTypes.shape({
    messages: PropTypes.object.isRequired,
  }),
  trans: PropTypes.shape({
    startDate: PropTypes.string,
    endDate: PropTypes.string,
  }),
};

export default createContainer({
  $queries: {
    changePage: { $call: 'ui.history.push' },
    i18n: {
      messages: true,
    },
    getTransactionDetails: {
      $call: 'reports.trans.getTransactionDetails'
    },
    downloads: {
      calendar: {
        open: {
          $call: 'open',
        },
        ...CalendarModal.getFragment('calendarModal'),
      },
      startDate: true,
      endDate: true,
      isDateBarClickable: true,
      setFalse: { $set: 'isDateBarClickable' },
      setStartDateEmpty: { $set: 'startDate' },
      setEndDateEmpty: { $set: 'endDate' },
      // downLoadReport: {$call: 'excelData' },
      result: true,
    },

    downLoadReport: { $call: 'reports.custom.downloads.excelData' },
    reports: {
      // calendar: {
      //   open: {
      //     $call: 'open'
      //   },
      //   ...CalendarModal.getFragment('calendarModal'),
      // },
      transactions: {
        showSpinner: true
      },
      custom: {
        downloads: {
          result: true
        },
        startDate: true,
        endDate: true,
      },
      trans: {
        calendar: {
          open: {
            $call: 'open'
          },
          ...CalendarModal.getFragment('calendarModal'),
        },
        startDate: true,
        endDate: true,
        dateDisplay: true,
        transactionHistoryList: true,
        isLoading: true,
        customSelectedTab: true,
        isTransactionSelected: true
      },
      closeDatePicker: true
    },
    getCustomDateRangeData: {
      $call: 'reports.trans.getSelectedRangeDataForCustomReport'
    },
    setTransactionHistoryData: {
      $call: 'reports.trans.setTransactionDetails'
    },
    setRange7Days: {
      $call: 'reports.trans.setRange7Days'
    },
    setRange30Days: {
      $call: 'reports.trans.setRange30Days'
    },
    setRange3Months: {
      $call: 'reports.trans.setRange3Months'
    },
    setRangeYTD: {
      $call: 'reports.trans.setRangeYTD'
    },
    setTransactionHistoryList: {
      $set: 'reports.trans.transactionHistoryList'
    },
    setTransSelectedTab: {
      $set: 'reports.trans.customSelectedTab'
    },
    setIsTransactionSelected: {
      $set: 'reports.trans.isTransactionSelected'
    },
    app: {
      global: {
        deviceInfo: {
          isTablet: true,
          width: true,
          height: true,
        }
      },
      user: {
        selectedPortfolioData: true
      },
    },
    screen: {
      height: true,
      width: true,
      isSmall: true,
    },
    auth: {
      langCode: true,
      documentDownloadDisabled: true,
    },
    settings: {
      currentEnvironment: {
        remoteUrl: true,
      },
    },
    setStartDate: { $set: 'reports.trans.startDate' },
    setEndDate: { $set: 'reports.trans.endDate' },
    setCustomStartDate: { $set: 'reports.custom.startDate' },
    setCustomEndDate: { $set: 'reports.custom.endDate' },
    setDatePickerClose: {
      $set: 'reports.closeDatePicker'
    },
    hideDWOPortfolioSelector: {
      $set: 'reports.hideDWOPortfolioSelector'
    },
    logoutPopup: {isVisible : true},
    portfolio:{
      overallMarketValue:{
        asOfDate: true,
        portfolioTransStartDate: true,
        portfolioTransEndDate: true
        
      }
    }
  },
}, ({ app, ...queries }) => ({
  ...queries,
  deviceInfo: app.global.deviceInfo,
  selectedPortfolioData: app.user.selectedPortfolioData
}))(TransactionHistory);

export { TransactionHistory };